export default function guest({ next, store }) {
    if (store.isLoggedIn) {
        return next({ path: '/dashboard' });
    }
    return next();
}